import { type Extent } from 'ol/extent';
import { type Projection } from 'ol/proj';
import type VectorSource from 'ol/source/Vector';

/**
 * Carica le feature della sorgente per l'extent dato, come Promise.
 *
 * La sorgente deve essere nuova e avere un `url` o un `loader`: sugli extent
 * già caricati o senza loader OpenLayers non emette eventi, e la Promise
 * resterebbe in sospeso.
 */
export function loadSourceFeatures(
  source: VectorSource,
  extent: Extent,
  projection: Projection,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const unbind = () => {
      source.un('featuresloadend', onLoadEnd);
      source.un('featuresloaderror', onLoadError);
    };
    const onLoadEnd = () => {
      unbind();
      resolve();
    };
    const onLoadError = () => {
      unbind();
      reject(new Error('[MapWidget] Caricamento delle feature fallito'));
    };

    source.on('featuresloadend', onLoadEnd);
    source.on('featuresloaderror', onLoadError);
    source.loadFeatures(extent, 1, projection);
  });
}
